import { loadable } from 'nordic/lazy';
import questions from './questions';

const Questions = loadable(() => import('../../../../components/questions/questions.mobile'));

export default questions(Questions);
